// src/Environment/environment.ts
var Environment = /* @__PURE__ */ function(Environment) {
	Environment["LOCAL"] = "local";
	Environment["STAGING"] = "staging";
	Environment["TESTING"] = "testing";
	Environment["CYPRESS_TEST"] = "cypress_test";
	Environment["EPHEMERAL"] = "ephemeral";
	Environment["PRODUCTION"] = "production";
	Environment["UNKNOWN"] = "unknown";
	return Environment;
}({});
// src/Environment/hostnames.ts
var LOCAL_HOSTNAMES = ["localhost", "127.0.0.1"];
var STAGING_HOSTNAMES = [
	"staging.color.com",
	"home.staging.color.com",
	"home.use1-a.eks.staging.color.com",
	"clinical.staging.color.com",
	"staging-clinical-web.monoweb.svc.cluster.local",
	"genomics-stb.joinallofus.org",
	"gp-staging.use1-a.eks.staging.color.com",
	"rhp-staging.use1-a.eks.staging.color.com",
	"aou-pdf.use1-a.eks.staging.color.com",
	"color-hub.use1-a.eks.staging.color.com",
	"hub.staging.color.com"
];
var TESTING_HOSTNAMES = ["gp-testing.use1-a.eks.staging.color.com"];
var PRODUCTION_HOSTNAMES = [
	"home.color.com",
	"home.use1-a.eks.color.com",
	"clinical.color.com",
	"prod-clinical-web.monoweb.svc.cluster.local",
	"genomics.joinallofus.org",
	"joinallofus.org",
	"rhp.aou.color.com",
	"aou-pdf.use1-a.eks.color.com",
	"hub.color.com"
];
// src/Environment/utils.ts
function isEnvironmentLocal() {
	return LOCAL_HOSTNAMES.includes(window.location.hostname);
}
function isEnvironmentStaging() {
	return STAGING_HOSTNAMES.includes(window.location.hostname);
}
function isEnvironmentTesting() {
	return TESTING_HOSTNAMES.includes(window.location.hostname);
}
function isEnvironmentProduction() {
	return PRODUCTION_HOSTNAMES.includes(window.location.hostname);
}
function isEnvironmentEphemeral() {
	return window.location.hostname.startsWith("ephemeral-") && window.location.hostname.endsWith(".use1-a.eks.color.dev");
}
function isEnvironmentLocalAndDevelopment() {
	return isEnvironmentLocal() && window.__ENV__ === "development";
}
function isEnvironmentCypressTest() {
	return isEnvironmentLocal() && window.Cypress !== void 0;
}
/**
* Returns the environment based on the hostname. Useful for enabling functionality (i.e. different log levels, tooling, etc),
* targeting different API hosts, and initializing 3rd party libraries based on the environment. If hostname is unknown, will
* return Environment.UNKNOWN.
*
* @returns {Environment} The current environment
*/
function getEnvironment() {
	if (isEnvironmentCypressTest()) return Environment.CYPRESS_TEST;
	if (isEnvironmentLocal()) return Environment.LOCAL;
	if (isEnvironmentStaging()) return Environment.STAGING;
	if (isEnvironmentTesting()) return Environment.TESTING;
	if (isEnvironmentProduction()) return Environment.PRODUCTION;
	if (isEnvironmentEphemeral()) return Environment.EPHEMERAL;
	return Environment.UNKNOWN;
}
/**
* Returns the environment based on the hostname. Useful for enabling functionality (i.e. different log levels, tooling, etc),
* targeting different API hosts, and initializing 3rd party libraries based on the environment. If hostname is unknown, will
* return `defaultEnv`.
*
* @returns {Environment} The current environment
*/
function getEnvironmentOrDefault(defaultEnv) {
	if (isEnvironmentLocal()) return Environment.LOCAL;
	if (isEnvironmentStaging()) return Environment.STAGING;
	if (isEnvironmentTesting()) return Environment.TESTING;
	if (isEnvironmentProduction()) return Environment.PRODUCTION;
	return defaultEnv;
}
export { isEnvironmentLocal as a, isEnvironmentStaging as c, isEnvironmentEphemeral as i, isEnvironmentTesting as l, getEnvironmentOrDefault as n, isEnvironmentLocalAndDevelopment as o, isEnvironmentCypressTest as r, isEnvironmentProduction as s, getEnvironment as t, Environment as u };

//# sourceMappingURL=Environment-DXNdmk85.js.map